import type { PlanTier } from '@/types';

export const PLAN_LABEL: Record<PlanTier, string> = {
  trial: 'Trial',
  expired: 'Expired',
  solo: 'Solo',
  team: 'Team',
  firm: 'Firm',
  pro: 'Pro',
  enterprise: 'Enterprise'
};

/** Opens the full site in the in-app Safari sheet (the shell sends other hosts there). */
export function openDesktop(path = '/') {
  window.open(`https://billable.to${path}`, '_blank');
}
